<!-- eslint-disable vue/multi-word-component-names -->
<script>
import Filtro02 from '@/components/shared/relatorio/filtros/Filtro02.vue'

export default {
  extends: Filtro02,

  methods: {
    carregarListaEntidades() {
      this.entidadeService.getListaEntidadesPorUsuario().then((res) => {
        this.entidades = res
      })
    },

    carregarListaConsignatarias() {
      this.consignatariaService
        .getConsignatariaPorRelatorio('ReservaCartao')
        .then((res) => {
          this.consignatarias = res
        })
    },
  },
}
</script>
